import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AlarmSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AlarmSVG;
